export enum UserRoleEntityType {
  Customer = 'Customer',
  Account = 'Account'
}
